/**
 * @typedef {('Auto'|'Home'|'Renter'|'Medsupp'|'Health'|'Life')} QuoteTypeLabel
 * @typedef {('AUTO'|'HOME'|'RENTER'|'MEDSUPP'|'HEALTH'|'LIFE')} QuoteTypeValue
 */

/**
 * Represents a type of insurance product.
 */
export class QuoteType {
  /**
   * The display label for the quote type
   * @type {QuoteTypeLabel}
   */
  label;

  /**
   * The value identifier for the quote type
   * @type {QuoteTypeValue}
   */
  value;

  /**
   * Creates a new QuoteType instance representing an insurance product type
   * @constructor
   * @param {QuoteTypeValue} value - The value identifier for the quote type
   * @param {QuoteTypeLabel} label - The display label for the quote type
   * @example
   * // Create a new Auto quote type
   * const autoQuote = new QuoteType('AUTO', 'Auto');
   */
  constructor(value, label) {
    this.value = value;
    this.label = label;
  }
}
